import { mdiFileDocumentMultipleOutline } from '@mdi/js'

export default {
  title: 'News',
  to: 'news-school',
  icon: mdiFileDocumentMultipleOutline,
  action: 'read',
  resource: 'NewsSchool',
}
